export default "__VITE_ASSET__Dq2d_k5L__"